/**
 * Name: Edit Playlist Main Reducer
 * Author: @Gaurav
 * Date: 21-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'GET_ALL_PLAYLIST_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'GET_ALL_PLAYLIST_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'GET_ALL_PLAYLIST_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
